import "./App.css";
import Register from "./Pages/Register";
import Login from "./Pages/Login";
import Badges from "./Pages/Badges";
import { Routes, Route, BrowserRouter, Navigate } from "react-router-dom";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import ProtectedRoute from "./Components/PrivateRoute";

import { useSelector } from "react-redux";
import Qualifications from "./Pages/Qualifications";
import SingleCertificate from "./Pages/SingleCertificate";
import Error404 from "./Components/404";
import Profile from "./Pages/Profile";
import ResetPassword from "./Pages/ResetPassword";
import TermsAndConditions from "./Pages/TermsAndConditions";
import Certificates from "./Pages/Certificates/index";
import Copyright from "./Components/Copyright";
import ForgotPassword from "./Pages/ForgotPassword";
import EmailConfirmation from "./Components/EmailConfirmed";
import RegisterGuest from "./Pages/RegisterGuest";
import EmailNotConfirmed from "./Components/EmailNotConfirmed";
import AboutUs from "./Pages/AboutUs";
import Resume from "./Pages/YourCv/components/Resume";
import PdfComponent from "./Pages/YourCv/components/PdfComponent";
import ExpiredLogout from "./Components/ExpiredLogout";
import CompetencePaths from "./Pages/CompetencePaths";
import SingleBadge from "./Pages/SingleBadge";
import SingleCompetencePath from "./Pages/SingleCompetencePath";
import CompetenceProfile from "./Pages/CompetenceProfile";
import CompetenceProfileSection from "./Pages/CompetenceProfileSection";
import Validator from "./Pages/Validator";
import SingleBadgeModel from "./Pages/SingleBadgeModel";
import { createContext, useMemo, useState } from "react";
import PublicBadge from "./Pages/PublicBadge";
import Ecommerce from "./Pages/Ecommerce/Ecommerce";
import PaymentSuccess from "./Pages/Ecommerce/PaymentComfirmation";
import ExternalBadge from "./Pages/ExternalBadge";
import WalletApp from "./Pages/Wallet";
import DeleteAccount from "./Pages/DeleteAccount";
import Callendar from "./Pages/Callendar";
import ScenarioCreator from "./Pages/ScenarioCreator";
import ScenarioList from "./Pages/ScenarioCreator/pages/ScenarioList";
import MapEditor from "./Pages/ScenarioCreator/components/MapEditor";
import ScenarioLoader from "./Pages/ScenarioCreator/components/ScenarioLoader";
import { theme as themeVr } from "./Pages/ScenarioCreator/theme";
import ReportsScreenWeb from "./Pages/Reports";
import ReportSingle from "./Pages/Reports/Report";
import MyGroups from "./Pages/Groups";
import VrCup from "./Pages/VrCup";


export const ColorModeContext = createContext({ toggleColorMode: () => { } });

function App() {
  const { user: currentUser } = useSelector((state) => state.auth);

  const [selectedScenario, setSelectedScenario] = useState(null);
  const [changeScenarioRef, setChangeScenarioRef] = useState(null);

  const [mode, setMode] = useState("light");

  const theme = createTheme({
    palette: {
      mode,
      primary: {
        // main: "#d2ab67",
        main: "#294e6b",
      },
      secondary: {
        main: "#404040",
      },
      fontWhite: {
        main: "#fff",
      },
      status: {
        main: "#a4ffaa",
      },
    },
  });

  const colorMode = useMemo(
    () => ({
      toggleColorMode: () => {
        setMode((prevMode) => (prevMode === "light" ? "dark" : "light"));
      },
    }),
    []
  );

  const isVrRoute = window.location.pathname.startsWith("/vr");


  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <Routes>
            {/* <Route path="/" element={<ProtectedRoute user={currentUser} />}> */}
            <Route element={<ProtectedRoute user={currentUser} />}>
              {currentUser &&
                (currentUser.user.userRole === "user" ||
                  currentUser.user.userRole === "admin") && (
                  <>
                    <Route path="/" element={<Navigate to="/yourcv" />} />
                    <Route path="/odznaki/:badgeId" element={<SingleBadge />} />
                  </>
                )}
              {currentUser && (currentUser.user.userRole === "guest" ||
                currentUser.user.userRole === "admin") && (
                  <>
                    <Route path="/" element={<AboutUs />} />
                  </>
                )}
              <Route path="/certificates" element={<Certificates />} />
              <Route
                path="/certificates/:certificateId"
                element={<SingleCertificate />}
              />
              <Route path="/qualifications" element={<Qualifications />} />
              <Route path="/odznaki" element={<Badges />} />
              <Route path="/odznaki/:badgeId" element={<SingleBadge />} />
              <Route
                path="/odznaki-do-odblokowania/:badgeId"
                element={<SingleBadgeModel />}
              />
              <Route path="/sciezki" element={<CompetencePaths />} />
              <Route
                path="/sciezki/:pathId"
                element={<SingleCompetencePath />}
              />

              <Route path="/profil-kompetencyjny">
                <Route
                  path="/profil-kompetencyjny/:profileId"
                  element={<CompetenceProfile />}
                />
                <Route
                  path="/profil-kompetencyjny/:profileId/sekcja/:sectionName"
                  element={<CompetenceProfileSection />}
                />
              </Route>
              <Route path="/profile" element={<Profile />} />
              <Route path="/yourcv">
                <Route path="/yourcv/" element={<Resume />} exact></Route>
                <Route
                  path="/yourcv/preview"
                  element={<PdfComponent />}
                ></Route>
              </Route>

              <Route path="/vr">
                <Route path="callendar" element={<Callendar />} />

                <Route
                  path="scenarios"
                  element={<ScenarioCreator />}
                >
                  <Route
                    index
                    element={
                      <ScenarioList setSelectedScenario={setSelectedScenario} />
                    }
                  />

                  <Route
                    path=":id"
                    element={
                      // <ThemeProvider theme={themeVr}>
                      <>
                        <MapEditor
                          selectedScenario={selectedScenario}
                          changeScenarioRef={changeScenarioRef}
                        />
                        <ScenarioLoader
                          selectedScenario={selectedScenario}
                          setSelectedScenario={setSelectedScenario}
                          onChangeScenario={setChangeScenarioRef}
                        />
                      </>
                      // </ThemeProvider>
                    }
                  />
                </Route>
              </Route>


              <Route path="/reports" element={<ReportsScreenWeb />} />

              <Route path="/report/:id" element={<ReportSingle />} />

              <Route path="/groups" element={<MyGroups />} />

              <Route path="/vr-cup" element={<VrCup />} />

              {/* <Route path="/groups/:id" element={<MyGroupsSingle />} /> */}

            </Route>
            {!currentUser && (
              <>
                <Route path="/" element={<Navigate to="/login" />} />
                <Route path="login" element={<Login />} />
                <Route path="register" element={<RegisterGuest />} />
                <Route path="register">
                  <Route path=":userId">
                    <Route path=":courseId">
                      <Route path=":firstname">
                        <Route path=":lastname">
                          <Route path=":email" element={<Register />}></Route>
                        </Route>
                      </Route>
                    </Route>
                  </Route>
                </Route>
                <Route
                  path="terms-and-conditions"
                  element={<TermsAndConditions />}
                />
                <Route path="forgot-password" element={<ForgotPassword />} />
                <Route path="reset-password" element={<ResetPassword />}>
                  <Route path=":code" element={<ResetPassword />} />
                </Route>
                <Route path="confirmed" element={<EmailConfirmation />} />
                <Route path="ecommerce" element={<Ecommerce />} />
                <Route path="payment" element={<PaymentSuccess />} />
                <Route path="delete-account" element={<DeleteAccount />} />
              </>
            )}
            <Route path="logout" element={<ExpiredLogout />} />
            <Route path="notconfirmed" element={<EmailNotConfirmed />} />
            <Route path="validator" element={<Validator />} />
            <Route path="public-badge/:slug" element={<PublicBadge />} />
            <Route path="*" element={<Error404 />} />
            <Route path="external-badge" element={<ExternalBadge />} />
            <Route path="wallet" element={<WalletApp />} />
          </Routes>
        </BrowserRouter>
        {!isVrRoute && <Copyright style={{ marginBottom: "25px" }} />}
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

export default App;
